import { render, staticRenderFns } from "./ReporteSerieBase.vue?vue&type=template&id=9278df4c&"
import script from "./ReporteSerieBase.vue?vue&type=script&lang=ts&"
export * from "./ReporteSerieBase.vue?vue&type=script&lang=ts&"
import style0 from "./ReporteSerieBase.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('9278df4c', component.options)
    } else {
      api.reload('9278df4c', component.options)
    }
    module.hot.accept("./ReporteSerieBase.vue?vue&type=template&id=9278df4c&", function () {
      api.rerender('9278df4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/ReportesNoSeriados/ReporteSerieBase.vue"
export default component.exports